import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Step = makeShortcode("Step");
const ProductScreenshot = makeShortcode("ProductScreenshot");
const OSButton = makeShortcode("OSButton");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Step checkpoint title="Verify error tracking" subtitle="Confirm events are being sent to PostHog" mdxType="Step">
      <p>{`Before proceeding, let's make sure exception events are being captured and sent to PostHog. You should see events appear in the activity feed.`}</p>
      <br />
      <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/SCR_20250729_ouxl_f788dd8cd2.png" imageDark="https://res.cloudinary.com/dmukukwp6/image/upload/SCR_20250729_owae_7c3490822c.png" alt="Activity feed with events" classes="rounded" className="mt-10" padding={false} mdxType="ProductScreenshot" />
      <OSButton asLink size="sm" variant="secondary" to="https://app.posthog.com/activity/explore" external={true} mdxType="OSButton">
    Check for exceptions in PostHog
      </OSButton>
    </Step>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      